import logo from "assets/images/logo.png";
import { colors } from "config/styles/themeColors";
import { fontSize } from "config/styles/fonts";

const styles = {
  headerWrap: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    height: {
      xs: "50px",
      lg: "70px",
    },
    padding: {
      xs: "10px 20px 10px 0px",
      lg: "15px 40px 15px 10px",
    },
    backgroundColor: colors.gray.main,
  },
  leftSide: {
    display: "flex",
    gap: "20px",
  },
  logo: {
    width: "150px",
    height: "100%",
    backgroundImage: `url(${logo})`,
    backgroundSize: "contain",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    ml: {
      xs: "-16px",
      lg: "0px",
    },
  },
  shortcutWrap: {
    display: {
      xs: "none",
      md: "flex",
    },
    gap: {
      md: "5px",
      lg: "20px",
    },
    alignItems: "center",
  },
  divider: {
    display: {
      xs: "none",
      lg: "block",
    },
    borderColor: colors.gray.disabled,
  },
  userInfoWrap: {
    display: "flex",
    gap: "30px",
  },
  userInfo: {
    display: {
      xs: "none",
      lg: "flex",
    },
    flexDirection: "column",
    alignItems: "flex-start",
  },
  user: {
    color: colors.background.default,
    fontSize: fontSize.s,
    fontWeight: 200,
    opacity: 0.7,
  },
  userRole: {
    display: "inline-block",
    color: colors.background.default,
    fontWeight: 900,
    fontSize: "15px",
  },
  logOutWrap: {
    display: "flex",
    flexDirection: {
      lg: "column",
    },
    alignItems: "center",
    gap: {
      xs: "10px",
      lg: "0px",
    },
    cursor: "pointer",
  },
  logOut: {
    color: colors.background.default,
    fontSize: fontSize.s,
    fontWeight: 200,
    opacity: 0.7,
  },
  logOutIcon: {
    fill: colors.background.default,
    width: "20px",
    height: "20px",
  },
  childrenWrap: {
    p: {
      xs: "10px 20px 0",
      lg: "10px 20px",
    },
  },
};

export default styles;
